import React from 'react';
import PartnerDetail from '../components/partner-network/PartnerDetail';

const PartnerDetailPage: React.FC = () => <PartnerDetail />;

export default PartnerDetailPage;
